import {Component} from '@angular/core';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'basic-spinner',
  templateUrl: 'basic-spinner.component.html',
  styleUrls: ['basic-spinner.component.scss']
})
export class BasicSpinnerComponent {

}
